module.exports = __webpack_public_path__ + "static/Redirection_Berlin_web-6853189aa030b923b09975ca4b9a74d7.webm";